import React from 'react'
import { Modal, Grid, TextField, Typography, Button, CircularProgress, IconButton, useTheme, useMediaQuery } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import { useStore } from '../../context/Context'
import useStyles from './styles'
import { register } from '../../api'

const RegisterForm = () => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const matchXS = useMediaQuery(theme.breakpoints.down('xs'))
  const { openModal, setOpenModal, setSignUpMode, isLoading, setIsLoading, setMessage, setSelectedTab } = useStore()
  const { handleSubmit, getFieldProps, errors, touched } = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: '',
      confirmPassword: ''
    },
    validationSchema: Yup.object({
      name: Yup.string().required('This field is a must!').min(3, 'Minimum of 3 characters!'),
      email: Yup.string().required('This field is a must!').email('This field is email formatted!'),
      password: Yup.string().required('This field is a must!').min(8, 'Minimum of 8 characters!'),
      confirmPassword: Yup.string().required('This field is a must!').oneOf([Yup.ref('password'), null], 'Passwords must match!')
    }),
    onSubmit: (values, actions) => {
      setIsLoading(true)

      const submit = async () => {
        const { name, email, password } = values
        try {
          await register(name, email, password)
          actions.resetForm()
          setMessage(state => ({
            ...state,
            msg: 'Registered',
            severty: 'success',
            open: true
          }))
          setOpenModal(false)
          setSelectedTab(0)
          history.push('/')
        } catch (error) {
          console.log(error)
          setMessage(state => ({
            ...state,
            msg: error.message,
            severty: 'error',
            open: true
          }))
          setOpenModal(false)
          setIsLoading(false)
        }
      }

      submit()
        .finally(() => {
          setIsLoading(false)
          handleClose()
        })
    }
  })

  const handleClose = () => {
    setSignUpMode(false)
    setOpenModal(false)
  }

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="login modal"
      aria-describedby="login modal for user sign in"
      className={classes.modal}
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        <Grid container direction="column" justifyContent="center" alignItems="center" style={{ top: '50%', left: '50%', transform: `translate(-50%, -50%)`, width: matchXS ? '90%' : '100%' }} className={classes.paper}>
          {isLoading ? (
            <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
              <CircularProgress />
            </Grid>
          ) : (
            <>
              <div style={{ position: 'absolute', top: 3, right: 3 }}>
                <IconButton onClick={handleClose}>
                  <ClearIcon style={{ color: 'white' }} />
                </IconButton>
              </div>
              <Grid item style={{ marginBottom: theme.spacing(3) }}>
                <Typography variant="h4">Register Form</Typography>
              </Grid>
              <Grid item container direction="column" spacing={3}>
                <Grid item>
                  <TextField
                    variant="outlined"
                    name="name"
                    label="Name"
                    {...getFieldProps('name')}
                    fullWidth
                    classes={{ root: classes.input }}
                  />
                  {touched.name && errors.name ? <Typography variant="caption" color="error">{errors.name}</Typography> : null}
                </Grid>
                <Grid item>
                  <TextField
                    variant="outlined"
                    name="email"
                    label="Email"
                    {...getFieldProps('email')}
                    fullWidth
                    classes={{ root: classes.input }}
                  />
                  {touched.email && errors.email ? <Typography variant="caption" color="error">{errors.email}</Typography> : null}
                </Grid>
                <Grid item>
                  <TextField
                    variant="outlined"
                    name="password"
                    type="password"
                    label="Password"
                    {...getFieldProps('password')}
                    fullWidth
                    classes={{ root: classes.input }}
                  />
                  {touched.password && errors.password ? <Typography variant="caption" color="error">{errors.password}</Typography> : null}
                </Grid>
                <Grid item>
                  <TextField
                    variant="outlined"
                    name="confirmPassword"
                    type="password"
                    label="Confirm Password"
                    {...getFieldProps('confirmPassword')}
                    fullWidth
                    classes={{ root: classes.input }}
                  />
                  {touched.confirmPassword && errors.confirmPassword ? <Typography variant="caption" color="error">{errors.confirmPassword}</Typography> : null}
                </Grid>
                <Grid item>
                  <Button variant="contained" type="submit" color="primary" className={classes.button} fullWidth={matchXS}>Sign Up</Button>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </form>
    </Modal>
  )
}

export default RegisterForm
